export default __webpack_public_path__ + "static/media/moreActions.856cbf72.svg";